/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useState } from "react";
import { db } from "~/db/db";
import { format } from "date-fns";
import { lastCreatedAt } from "~services/utils/helpers";
import { useGetMissoes } from "~pages/RouteOptimizationV2/hooks/useRoteirizacao";
import { useLiveQuery } from "dexie-react-hooks";

const useMissao = ({ clienteId }) => {
  const [missoes, setMissoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [lastCreatedAtDate, setLastCreatedAtDate] = useState("");
  const [enabled, setEnabled] = useState(false);

  const missoesRequest = useGetMissoes(enabled, clienteId);

  useLayoutEffect(() => {
    setEnabled(true);
  }, []);

  useEffect(() => {
    if (missoesRequest.isSuccess && missoesRequest.data?.data) {
      db.missoes.where("clienteId").equals(Number.parseInt(clienteId)).delete();
      for (const insert of missoesRequest.data?.data || []) {
        db.missoes.bulkAdd(insert);
      }
    }
  }, [missoesRequest.data]);

  useLiveQuery(() => {
    const fetchMissoes = async (clienteId) => {
      setLoading(true);
      const idCliente = Number.parseInt(clienteId, 10);
      const thisMissoes = [];
      await db.missoes
        .where("clienteId")
        .equals(idCliente)
        .each((missoesItem) => {
          thisMissoes.push(missoesItem);
        });

      setTotal(thisMissoes.length);
      setLastCreatedAtDate(lastCreatedAt(thisMissoes));

      const newMissoes = (thisMissoes || []).sort((a, b) => a.prioridade - b.prioridade);
      const groupedMissoes = {};
      for (const curr of newMissoes) {
        if (!groupedMissoes[curr.tipo]) {
          groupedMissoes[curr.tipo] = { tipo: curr.tipo, missoes: [] };
        }
        groupedMissoes[curr.tipo].missoes.push(curr);
      }

      setMissoes(Object.values(groupedMissoes));
      setLoading(false);
    };

    fetchMissoes(clienteId);
  }, [clienteId]);

  return {
    missoes: {
      missoes,
      total,
      lastCreatedAtDate,
    },
    loading,
  };
};

export default useMissao;
